import { useQuery } from '@tanstack/react-query';
import { getStudentPerformance } from '../api';
import { useAuth } from '../hooks';

export const useStudentPerformance = ({ duration, subject }) => {
  const { token } = useAuth();
  return useQuery({
    queryKey: ['student-performance', duration, subject || ''],
    queryFn: () => getStudentPerformance({ token, duration, subject }),
    enabled: !!token,
    keepPreviousData: true
  });
};
